<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('destinatary types')"
      :columns="columns"
      resource_url="/account-request/destinatary-type/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar -->
    <type-modal ref="type_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import TypeModal from "./type_modal/Index.vue";

import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  format_date_time,
  error_message,
} from "@/utils";

export default {
  name: "AccountRequestDestinataryTypeDataTable",
  components: {
    GenericTable,
    TypeModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("name"),
          data: (row) => row.name || "",
        },
        {
          title: this.$t("actions"),
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: (e) => {
                  this.edit(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  this.delete(row);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.type_modal.show_modal();
    },
    edit(row) {
      this.$refs.type_modal.show_modal(row.uuid);
    },
    delete(row) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete destinatary type?"),
        v,
        () => {
          del("/account-request/destinatary-type", { uuid: row.uuid })
            .then(() => {
              v.refresh_datatable();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
